import CashierDetailsResume from './CashierDetailsResume';

export default CashierDetailsResume;